// src/config/routes/public.routes.ts
import { lazy } from 'react';
import { RouteConfig } from 'src/types/route-config.types';

export const authRoutes: RouteConfig[] = [
    {
        name: "login",
        path: "/login",
        showInSideNav: false,
        access: ["*"], // Accessible to everyone
        component: lazy(() => import('src/pages/auth/login/LoaginPage')),
        breadcrumbPath: ["auth", "login"],
        icon: "signup",
        order: 2,
        meta: {
            title: "Create Your Account",
            description: "Join our platform and get started today",
        }
    },
    {
        name: "signup",
        path: "/signup",
        showInSideNav: false,
        access: ["*"], // Accessible to everyone
        component: lazy(() => import('src/components/auth/signup/SignupLayout')),
        breadcrumbPath: ["auth", "signup"],
        icon: "signup",
        order: 2,
        children: [
            {
                name: "Sign up Form",
                path: "",
                showInSideNav: false,
                access: ["*"], // Accessible to everyone
                component: lazy(() => import('src/pages/auth/signup/SignUpPage')),
                breadcrumbPath: ["auth", "signup"],
                icon: "signup",
                order: 2,
                meta: {
                    title: "Create Your Account",
                    description: "Join our platform and get started today",
                }
            },
            {
                name: "otp-verification",
                path: "verify",
                showInSideNav: false,
                access: ["*"], // Accessible to everyone
                component: lazy(() => import('src/pages/auth/signup/OtpVerification')),
                breadcrumbPath: ["auth", "signup", "verify"],
                icon: "signup",
                order: 2,
                meta: {
                    title: "Create Your Account",
                    description: "Join our platform and get started today",
                }
            },
        ],
        meta: {
            title: "Create Your Account",
            description: "Join our platform and get started today",
        }
    },
    {
        name: "forgot-password",
        path: "/forgot-password",
        showInSideNav: false,
        access: ["*"], // Accessible to everyone
        component: lazy(() => import('src/components/auth/forgot-password/ForgotPasswordLayout')),
        breadcrumbPath: ["auth", "forgot-password"],
        icon: "signup",
        order: 2,
        children: [
            {
                name: "Verify User",
                path: "",
                showInSideNav: false,
                access: ["*"], // Accessible to everyone
                component: lazy(() => import('src/pages/auth/forgot-password/VerifyUserPage')),
                breadcrumbPath: ["auth", "signup"],
                icon: "signup",
                order: 2,
                meta: {
                    title: "Verify User",
                    description: "To reset your password, provideryour details",
                }
            },
            // {
            //     name: "reset-password",
            //     path: "reset-password",
            //     showInSideNav: false,
            //     access: ["*"], // Accessible to everyone
            //     component: lazy(() => import('src/pages/auth/signup/OtpVerification')),
            //     breadcrumbPath: ["auth", "signup", "verify"],
            //     icon: "signup",
            //     order: 2,
            //     meta: {
            //         title: "Create Your Account",
            //         description: "Join our platform and get started today",
            //     }
            // },
        ],
        meta: {
            title: "Create Your Account",
            description: "Join our platform and get started today",
        }
    },
    {
        name: "reset-password",
        path: "/reset-password",
        showInSideNav: false,
        access: ["*"], // Accessible to everyone
        component: lazy(() => import('src/pages/auth/reset-password/ResetPasswordPage')),
        breadcrumbPath: ["auth", "login"],
        icon: "signup",
        order: 2,
        meta: {
            title: "Reset Password",
            description: "Set a new password for your account.",
        }
    },
]
